import React from 'react';

import { Alert } from '@mui/material';

import { TourFormDeparture } from '~/services/ToursService';

import { DepartureInventory } from '~/types/tours/inventory';

import DepartureInventoryPanel from './DepartureInventoryPanel';
import { ScalePricingItem } from './departureInventory';

interface Props {
  /** The tour's departures, chronologically, which a whole-tour scale prices all of. */
  departures: Array<TourFormDeparture>;
  selectedDepartureId: string;
  inventory?: DepartureInventory;
  snapshotDate?: number;
  onDateChange: (date: number) => void;
  /** The service's sliding scale, which applies to every departure alike. */
  items: Array<ScalePricingItem>;
  isLoading: boolean;
  error?: { message: string } | null;
  showCosts?: boolean;
  showCostChart?: boolean;
}

/**
 * Inventory for a service priced with one scale across the whole tour.
 *
 * The parent owns the departure selector so it can sit above the cost-price
 * heading while this section remains beside the inventory detail.
 */
export default function TourInventorySection({
  departures,
  selectedDepartureId,
  inventory,
  snapshotDate,
  onDateChange,
  items,
  isLoading,
  error,
  showCosts,
  showCostChart,
}: Props) {
  if (!isLoading && !departures.length) {
    return <Alert severity="info">This tour has no upcoming departures, so there is no inventory to track.</Alert>;
  }

  return selectedDepartureId ? (
    <DepartureInventoryPanel
      inventory={inventory}
      items={items}
      isLoading={isLoading}
      error={error}
      snapshotDate={snapshotDate}
      onDateChange={onDateChange}
      showCosts={showCosts}
      showCostChart={showCostChart}
    />
  ) : (
    <Alert severity="info">Choose a departure to see what has been sold against it.</Alert>
  );
}
